import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body pt-0" }
const _hoisted_5 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_6 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'admin-banks-rates'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.translate('bankRatesListing')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: bank }) => [
              _createTextVNode(_toDisplayString(bank.id), 1)
            ]),
            "cell-notClientPercentage": _withCtx(({ row: bank }) => [
              _createTextVNode(_toDisplayString(bank.notClientPercentage), 1)
            ]),
            "cell-percentage": _withCtx(({ row: bank }) => [
              _createTextVNode(_toDisplayString(bank.percentage), 1)
            ]),
            "cell-repaymentPeriod": _withCtx(({ row: bank }) => [
              _createTextVNode(_toDisplayString(bank.repaymentPeriod), 1)
            ]),
            "cell-isActive": _withCtx(({ row: bank }) => [
              (bank.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: bank }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editBank(bank.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ])
              ], 8, _hoisted_7)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}